import { makeObservable, observable } from 'mobx';

import BaseStore from './BaseStore';
import LeadsAPI from '../api/leads';

class LeadsStore extends BaseStore {
  isSent = false;

  constructor() {
    super();

    makeObservable(this, {
      isSent: observable,
    });
  }

  create = async (payload, setStatus, setSubmitting) => {
    try {
      await LeadsAPI.create(payload);
      setStatus({ success: true });
      this.isSent = true;
    } catch (errors) {
      setStatus({ success: false });
    } finally {
      setSubmitting(false);
    }
  };
}

export default new LeadsStore();
